module.exports = __webpack_public_path__ + "img/LOCK.be5e24fa.svg";